import { getProductFamily } from '@/utils/stripe/composables/product'
import { maLogger } from '@/base/logger'
import { PRODUCTS } from '@/base/constants/authorization'
import { accountQueryKey, fetchUserProducts, useFetchUserProductsQuery } from '@/api/services/account'
import { queryClient } from '@/api/query-client'

const transformUserProducts = data => data?.products?.filter(({ active }) => active) || []

export function useUserProducts() {
  const { data: activeProducts } = useFetchUserProductsQuery({
    options: {
      placeholderData: [],
      select: transformUserProducts,
    },
  })

  return activeProducts
}

export async function getUserProducts() {
  try {
    const data = await queryClient.ensureQueryData({
      queryKey: accountQueryKey.fetchUserProducts(),
      queryFn: fetchUserProducts,
    })

    return transformUserProducts(data)
  }
  catch (error) {
    maLogger.warn('[useUserProducts] Failed to load user products:', error)
    return []
  }
}

export async function getActiveSubscriptionId(stripeProductId) {
  const userProducts = await getUserProducts()
  const productFamily = getProductFamily(stripeProductId)
  return userProducts.find(({ product }) => product == productFamily?.productKey)?.stripeSubscriptionId
}

export async function isFreemiumUser() {
  const userProducts = await getUserProducts()
  const freemiumProducts = [PRODUCTS.MA_FREEMIUM, PRODUCTS.SA_FREEMIUM]
  const paidProducts = userProducts.filter(({ name }) => !freemiumProducts.includes(name))
  return paidProducts.length === 0
}
